function Error(props) {
  return <div className=""> {props.message}</div>;
}

export default Error;
